<template>
  <div>
    <el-row :gutter="20">
      <!--<el-col :span="3">-->
       <!--<el-form ref="form" label-width="100px">-->
          <!--<div class="content-bottom-padded">-->
              <!--<el-upload class="fl" style="margin-right: 10px" action="" :on-change="uploadHandleChange" :auto-upload="false" :show-file-list="false" >-->
                <!--<el-button size="small" type="primary">点击上传【覆盖】</el-button>-->
              <!--</el-upload>-->
          <!--</div>-->
       <!--</el-form>-->
      <!--</el-col>-->
        <el-col :span="3">
            <div>
                <el-upload class="fl" style="margin-right: 10px" action="" :on-change="uploadHandleChangeAdd" :auto-upload="false" :show-file-list="false" >
                    <el-button size="small" type="primary">点击上传【追加】</el-button>
                </el-upload>
            </div>
        </el-col>
      <el-col :span="5">
        <el-input placeholder="策略名称" v-model="params.name" style="width: 100%" size="mini"><el-button slot="append" icon="el-icon-search" @click="searchData"></el-button></el-input>
      </el-col>
    </el-row>
   <el-table :data="catesList" :height="wheight-130" v-loading="loading">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="apprangeid" label="策略id" width="100"></el-table-column>
      <el-table-column prop="apprange_name" label="策略名" width="120"></el-table-column>
      <el-table-column prop="apprange_status" align="center" label="状态" width="100" >
          <template slot-scope="scope">
              <el-switch v-model="scope.row.apprange_status"  active-value="1" inactive-value="0" active-color="#13ce66"  inactive-color="#ff4949" @change="switchAuth(scope.$index, scope.row)"></el-switch>
          </template>
      </el-table-column>
       <el-table-column prop="apprange_status" align="center" label="前端领取显示" width="100" >
           <template slot-scope="scope">
               <el-switch v-model="scope.row.show_flag"  active-value="1" inactive-value="0" active-color="#13ce66"  inactive-color="#ff4949" @change="switchAuthShow(scope.$index, scope.row)"></el-switch>
           </template>
       </el-table-column>
      <el-table-column prop="perputoutvalue" label="代金券金额" width="100"></el-table-column>
      <el-table-column prop="limit_amount" label="最低消费金额" width="100"></el-table-column>
      <el-table-column prop="off_time" label="有效天数" width="100"></el-table-column>
      <el-table-column prop="apprange_mode" label="赠送策略" width="100"></el-table-column>
      <el-table-column prop="entered_by" label="录入人" width="100"></el-table-column>
      <el-table-column prop="startdate" label="生效日期" width="230">
        <template slot-scope="scope">
        <el-button @click="setDateTime(scope.row)" v-if="scope.row.startdate >0" >{{scope.row.startdate| datetime('yyyy-MM-dd') }}-{{scope.row.enddate| datetime('yyyy-MM-dd')}}</el-button>
        <el-button @click="setDateTime(scope.row)" v-else >设置生效时间</el-button>

         </template>
      </el-table-column>
      <el-table-column prop="created" label="录入日期" width="180">
        <template slot-scope="scope">
          <span>{{scope.row.created | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
        </template>
      </el-table-column>
       <el-table-column prop="rel_card_id" label="关联线上优惠券id" width="100">
           <template slot-scope="scope" >
               <el-input v-model="scope.row.rel_card_id" @change="setRelId(scope.row)" size="mini"></el-input>
           </template>
       </el-table-column>
    </el-table>
    <div v-if="total_count > params.pageSize" class="content-center content-top-padded">
     <el-pagination
     layout="prev, pager, next"
     @current-change="handleCurrentChange"
     :current-page.sync="params.page"
     :total="total_count" :page-size="params.pageSize">
     </el-pagination>
   </div>
    <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="setDateTime">

    <div class="block">
      <el-date-picker
        v-model="value2"
        type="datetimerange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        :picker-options="pickerOptions">
      </el-date-picker>

  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="timeSubmit">确 定</el-button>
  </span>
</el-dialog>
   <el-dialog title="添加、编辑分类" width="40%" :visible.sync="memberTagDialog" :before-close="handleCancelLabelsDialog">
     <template>
       <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">
         <el-form-item class="content-left" label="分类名称" prop="name" :rules="[{ required: true, message: '请输入分类名称', trigger: 'blur' }]">
           <el-input placeholder="请输入标签名称" v-model="form.name"></el-input>
         </el-form-item>
         <el-form-item class="content-left" label="分类说明">
           <el-input type="textarea" :rows="3" placeholder="请输入分类说明" v-model="form.remark"></el-input>
         </el-form-item>
         <el-form-item class="content-left" label="前台显示">
           <el-radio-group v-model="form.is_show" size="small">
             <el-radio label="1" border>显示</el-radio>
             <el-radio label="0" border>不显示</el-radio>
           </el-radio-group>
         </el-form-item>

         <el-form-item class="content-center">
           <el-button type="primary" @click="saveCateData">确定保存</el-button>
         </el-form-item>
       </el-form>
     </template>
   </el-dialog>
  </div>
</template><script>
  import { mapGetters } from 'vuex'
  import { handleUploadFileImport, getOfflineList,saveOffline as saveData,deleteCate,handleUploadFileImportAdd,setCouponDate,updateOffineRel} from '../../../api/cardticket'
  export default {
    data () {
      return {
        isEdit: false,
        catesList: [],
        loading: false,
        total_count: 0,
        params: {
          page: 1,
          pageSize: 20,
          name: '',
        },
        form: {},
        memberTagDialog: false,
        dialogVisible:false,
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        value2: '',
        dataRow:'',
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      setDateTime(row){
        this.dialogVisible=true
        this.dataRow=row;
      },
      timeSubmit(){
        var date={};
        date['start']=this.dateStrToTimeStamp(this.value2[0]);date['end']=this.dateStrToTimeStamp(this.value2[1])
        date.id=this.dataRow.id
        // console.log(date)
        // this.dialogVisible=false
        this.params = date
        console.log(this.params)
        setCouponDate(this.params).then(res => {
          this.dialogVisible = false
          if (res.data) {
                    this.$message({
                        type: 'success',
                        message: '修改成功'
                    })
                    return
                }else {
                  this.$message({
                      type: 'error',
                      message: '修改失败'
                  })
                  return
                }
          }).catch( error => {
          this.dialogVisible = false
        })
      },

      dateStrToTimeStamp (str) {
      return Date.parse(new Date(str))/1000
    },
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getDataList()
      },
      addTemplate () { // 添加商品
        this.memberTagDialog = true
        this.form = {cate_id: '',description: ''}
      },
      preview (index, row) { // 预览弹框
        this.dialogVisible = true
        this.dataInfo = row
      },
      searchData () {
        this.params.page = 1
        this.getDataList()
      },
      uploadHandleChange (file, fileList) {
        let params = {isUploadFile: true, file:file.raw}
        handleUploadFileImport(params).then(response => {
          this.$message({
            type: 'success',
            message: '上传成功，等待处理'
          })
          this.getDataList()
        })
      },
      uploadHandleChangeAdd(file, fileList){
          let params = {isUploadFile: true, file:file.raw}
          handleUploadFileImportAdd(params).then(response => {
              this.$message({
                  type: 'success',
                  message: '上传成功，等待处理'
              })
              this.getDataList()
          })
      },
      setRelId(row){
          // 更新关联优惠券id
          let upparams = {id:row.id,apprangeid:row.apprangeid,card_id:row.rel_card_id}
            updateOffineRel(upparams).then(response => {

                if(response.data.data.status == true) {
                    this.$message({
                        type: 'success',
                        message: '更新成功'
                    })
                }else{
                    this.$message({
                        type: 'failed',
                        message: '更新失败'
                    })
                }
          })
      },
      getDataList () {

        this.loading = true
        getOfflineList(this.params).then(response => {

          this.catesList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },
      typesearch (){
          this.params.page = 1
          getOfflineList({page:1,pageSize:this.params.pageSize,type:this.params.type}).then(res=>{
              if(res.data){
                  this.category = res.data.data.list
              }
          })
          this.getDataList()
      },
      deleteAction (index, row) {

        this.$confirm('此操作将删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          deleteCate(row.cate_id).then(response => {

            this.catesList.splice(index, 1)
            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 5 * 1000
            })
          }).catch(() => {
            this.$message({
              type: 'error',
              message: '删除失败'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      getTaskTime (strDate) {
          let date = new Date(strDate)
          let y = date.getFullYear()
          let m = date.getMonth() + 1
          m = m < 10 ? ('0' + m) : m
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          let str = y+"-"+m+"-"+d
          return str
      },
      switchAuth(index, row) {

          let params = {
              'apprange_status': row.apprange_status,
          }
          saveData(row.id,params).then(res => {
              if (res.data.data) {
                  this.$message({
                      message: '操作成功',
                      type: 'success',
                      duration: 2 * 1000
                  })
                  this.getDataList()
              }
          })
      },
      switchAuthShow(index, row) {

            let params = {
                'show_flag': row.show_flag,
            }
            saveData(row.id,params).then(res => {
                if (res.data.data) {
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 2 * 1000
                    })
                    this.getDataList()
                }
            })
      },
      getTimeStr (date) {
        return this.getTaskTime(new Date(parseInt(date) * 1000))
      },
      handleCancelLabelsDialog () {
        this.memberTagDialog = false
      },
      saveCateData () {
        this.memberTagDialog = false
        if (this.form.cate_id) {
          updateCate(this.form.cate_id, this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getDataList()
            }
          })
        } else {
          saveCate(this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getDataList()
            }
          })
        }
      }
    },
    mounted () {
      this.getDataList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// offline.vue?8144b7b0